import {
  addMessageListener,
  removeMessageListener,
} from "./messaging/transport";
// Listener which removes itself when it returns true.
type RemovableListener = (msgEvent: MessageEvent) => boolean;

// Adds listener which removes itself when listener returns true.
const addSelfRemovingListener = (listener: RemovableListener) => () => {
  const listenerFunc = (msgEvent: MessageEvent) => {
    if (listener(msgEvent)) {
      removeMessageListener(listenerFunc);
    }
  };
  addMessageListener(listenerFunc);
};

export default addSelfRemovingListener;
